"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePressEscape = usePressEscape;
exports.default = void 0;

var _react = require("react");

/**
 * usePressEscape - This hook is used for cases where we need to perform an
 * action when the user presses the escape key. Usually, this indicates that the
 * user wants to cancel performing an action or otherwise back out of their
 * current view.
 *
 * It accepts a value for the function that will be called when the user presses
 * the ESC key.
 */
function usePressEscape(callback) {
  const handleKeyPress = (0, _react.useCallback)(({
    key
  }) => {
    const pressedEsc = key === 'Esc' || key === 'Escape';

    if (pressedEsc && typeof callback === 'function') {
      callback();
    }
  }, [callback]);
  (0, _react.useEffect)(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);
}

var _default = usePressEscape;
exports.default = _default;
//# sourceMappingURL=usePressEscape.js.map